import React from 'react';
import { ParallaxProvider, config } from '@adc/parallax-component-library';
import { useTheme } from 'Hooks';
const Providers = ({ children }) => {
    const { theme } = useTheme();
    const defaultTheme = theme.endsWith('Dark') ? 'dark' : 'light';
    return (React.createElement(ParallaxProvider, { config: config, locale: "en-US", dir: "ltr", defaultTheme: defaultTheme }, children));
};
export default Providers;
